import { render, staticRenderFns } from "./TagsManagerDialogInfoBox.vue?vue&type=template&id=58b15eb7&scoped=true&"
import script from "./TagsManagerDialogInfoBox.vue?vue&type=script&lang=js&"
export * from "./TagsManagerDialogInfoBox.vue?vue&type=script&lang=js&"
import style0 from "./TagsManagerDialogInfoBox.vue?vue&type=style&index=0&id=58b15eb7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b15eb7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
